import styled from 'styled-components';
import { COLOR_WHITE, COLOR_RED } from '../../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../../assets/styles/breakpoints';

export default styled.tr`
  background: ${COLOR_WHITE};
  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px;
      }
      &:last-child {
        border-top-right-radius: 0px;
      }
    }
  }
  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }

  td {
    padding: 18px 0px;
    text-align: center;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      text-align: left;
      padding-left: 32px;
      width: 170px;
      &:after {
        width: calc(100% - 32px);
        right: 0px;
        left: auto;
      }
    }
    &:last-child {
      padding-right: 32px;
      text-align: center;
      width: 190px;
      &:after {
        width: calc(100% - 32px);
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    td {
      padding: 18px 0px;
      text-align: center;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: 0px;
        height: 1px;
        width: 100%;
        background: rgba(47, 46, 65, 0.1);
        left: 0;
      }
      &:first-child {
        text-align: left;
        padding-left: 16px;
        width: auto;
        &:after {
          width: calc(100% - 16px);
          right: 0px;
          left: auto;
        }
        p {
          &:last-child {
            display: block;
          }
        }
      }
      &:last-child {
        padding-right: 16px;
        text-align: right;
        width: auto;
        &:after {
          width: calc(100% - 16px);
          right: auto;
          left: 0px;
        }
      }
    }
  }
`;

export const RedAlertSC = styled.span`
  width: 16px;
  height: 16px;
  background: ${COLOR_RED};
  color: ${COLOR_WHITE};
  margin-top: 5px;
  margin-left: 8px;
  font-size: 12px;
  float: right;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
`;
